import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';

const titleFeeSel = state => state.titlefees.titleFee;
const lienFeeSel = state => state.titlefees.lienFee;
const fastTitleFeeSel = state => state.titlefees.fastTitleFee;
const lateFeeSel = state => state.titlefees.lateFee;
const lemonLawFeeSel = state => state.titlefees.lemonLawFee;
const mobileHomeLengthSel = state => state.mobilehome.mobileHomeLength;

const mobileHomeTotalSelector = createSelector(
  [titleFeeSel, lienFeeSel, fastTitleFeeSel, lateFeeSel, lemonLawFeeSel, mobileHomeLengthSel],
  (title, lien, fast, late, lemon, mobileHomeLength) => {
    const totalFees = [title, lien, fast, late, lemon].reduce((acc, val) => {
      return acc + Number(val);
    }, 0);

    return precise(mobileHomeLength * totalFees);
  },
);

export default mobileHomeTotalSelector;



// WEBPACK FOOTER //
// ./src/selectors/titleTotal.selector.js